import { SVGProps, useMemo } from 'react';
import chroma from 'chroma-js';
import { BaseContainerComponentPropsType } from '../../util/types';
import AvatarArtwork, { type RenderShadowFn } from '../AvatarArtwork';
import { avatarDefaultBackgroundColors } from '../../config/avatarColors';

const renderShadow: RenderShadowFn = () => null;

const DEFAULT_BG = avatarDefaultBackgroundColors.moon;

export let MoonAvatarArtwork = (
  props: {
    backgroundColor?: string;
  } & BaseContainerComponentPropsType &
    SVGProps<SVGSVGElement>,
) => {
  const bg = props.backgroundColor || DEFAULT_BG;
  const starColor = useMemo(() => chroma(bg).brighten(3).hex(), [bg]);

  return (
    <AvatarArtwork
      {...props}
      defaultBackgroundColor={DEFAULT_BG}
      renderShadow={renderShadow}
    >
      <>
        <circle cx="9.35" cy="38.76" r=".37" style={{ fill: starColor }} />
        <circle cx="5.29" cy="29.62" r=".19" style={{ fill: starColor }} />
        <circle cx="15.26" cy="42.05" r=".19" style={{ fill: starColor }} />
        <circle cx="29.41" cy="5.58" r=".19" style={{ fill: starColor }} />
        <circle cx="13.35" cy="7.02" r=".19" style={{ fill: starColor }} />
        <circle cx="38.91" cy="12.97" r=".19" style={{ fill: starColor }} />
        <circle cx="37.36" cy="36.69" r=".19" style={{ fill: starColor }} />
        <circle cx="21.76" cy="3.02" r=".19" style={{ fill: starColor }} />
        <circle cx="41.65" cy="16.61" r=".39" style={{ fill: starColor }} />
        <circle cx="27.74" cy="3.02" r=".39" style={{ fill: starColor }} />
        <circle cx="40.09" cy="37.08" r=".39" style={{ fill: starColor }} />
        <circle cx="29.99" cy="42.44" r=".39" style={{ fill: starColor }} />
        <circle cx="15.26" cy="39.3" r=".39" style={{ fill: starColor }} />
        <circle cx="39.3" cy="9.39" r=".39" style={{ fill: starColor }} />
      <g transform="translate(24, 24) scale(0.95) translate(-24, -24)">
      <g>
        <path
          d="M23.79,39.06c-8.38,0-15.21-6.82-15.21-15.21s6.82-15.21,15.21-15.21,15.21,6.82,15.21,15.21v.39c-.2,7.4-5.63,13.56-12.94,14.65-.74.11-1.51.17-2.27.17Z"
          style={{ fill: '#f1cc5b' }}
        />
        <path
          d="M23.79,9.02c8.18,0,14.83,6.65,14.83,14.83,0,.13,0,.25,0,.39-.18,7.21-5.49,13.22-12.62,14.28-.72.11-1.47.16-2.21.16-8.18,0-14.83-6.65-14.83-14.83s6.65-14.83,14.83-14.83M23.79,8.27c-8.61,0-15.58,6.98-15.58,15.58s6.98,15.58,15.58,15.58c.79,0,1.56-.06,2.32-.17,7.38-1.1,13.06-7.37,13.25-15,0-.14,0-.27,0-.41,0-8.61-6.98-15.58-15.58-15.58h0Z"
          style={{ fill: '#b59745' }}
        />
      </g>
      <path
        d="M10.63,14.1c-.23.22-.6.22-.91.15s-.62-.19-.94-.17c-.31.02-.6.19-.85.37-.7.49-1.34,1.26-1.22,2.1.13-.11-.05.33.06.46s.12.31.14.48c.04.36.07.72.11,1.09"
        style={{
          fill: '#f1cc5b',
          stroke: '#bda047',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
        }}
      />
      <path
        d="M7.57,16.85c.71-.38,1.23-1.1,1.37-1.89"
        style={{
          fill: 'none',
          stroke: '#bda047',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: 0.75,
        }}
      />
      <polygon
        points="17.2 28.41 3.7 23.44 7.69 12.61 21.18 17.58 23.52 24.59 17.2 28.41"
        style={{
          fill: '#6d6f7d',
          stroke: '#52545e',
          strokeMiterlimit: 10,
          strokeWidth: 0.75,
        }}
      />
      <ellipse
        cx="5.7"
        cy="18.03"
        rx="5.77"
        ry="2.88"
        transform="translate(-13.19 17.15) rotate(-69.8)"
        style={{
          fill: '#6d6f7d',
          stroke: '#52545e',
          strokeMiterlimit: 10,
          strokeWidth: 0.75,
        }}
      />
      <ellipse
        cx="5.7"
        cy="18.03"
        rx="3.33"
        ry="1.08"
        transform="translate(-13.19 17.15) rotate(-69.8)"
        style={{
          fill: '#52545e',
          stroke: '#52545e',
          strokeMiterlimit: 10,
          strokeWidth: 0.75,
        }}
      />
      <polygon
        points="21.38 19.6 10.14 15.28 9.97 14.34 21.73 18.67 21.38 19.6"
        style={{ fill: '#9396a8' }}
      />
      <path
        d="M12.53,29.6s2.2-1.42,5.31-3.74c.78-.58,1.31-1.03,1.86-2,2.21-3.93-.66-9.2-.66-9.2l4.27-2.13,9.81,14.28-15.17,9.72-5.43-6.92Z"
        style={{ fill: '#f1cc5b' }}
      />
      <polygon
        points="19.4 32.23 19.26 31.37 27.09 30.02 28.46 31.48 28.33 31.7 23.79 32.82 19.4 32.23"
        style={{ fill: '#fefefe' }}
      />
      <path
        d="M21.36,33.48c-1.24-.32-2.38-1.19-2.29-1.74.05-.29,1.07.09,4.72.06,2.67-.02,4.37-.47,4.67-.32.36.17-1.01,1.51-1.94,1.76-1.52.42-3.26.72-5.16.24Z"
        style={{ fill: '#b58b48' }}
      />
      <path
        d="M19.07,31.7c.61-1.48,3.02-2.25,4.68-2.24,1.14,0,2.23-.65,3.07-.25.96.45,1.47,1.77,1.69,2.33-.15.03-.32.06-.75-.12-.47-.19-1.04-.56-2.11-.55-1.01.01-3.37.59-4.3.8-1.21.27-1.76.29-2.28.04Z"
        style={{ fill: '#91703a' }}
      />
      <path
        d="M14.73,28.41c.02-.48.31-.95.74-1.18.53-.29,1.2-.21,1.73-.51.53-.3.8-.9,1.19-1.36.52-.61,1.31-.97,2.11-1.02"
        style={{
          fill: '#f1cc5b',
          stroke: '#b59745',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: 0.75,
        }}
      />
      <path
        d="M13.87,31.58c.53-.23,1.14.25,1.28.8s-.02,1.14-.14,1.7c-.05.25-.09.53.04.75.24.39.88.31,1.16-.05s.3-.85.26-1.31-.1-.93.06-1.36c.14-.37.46-.68.85-.75s.83.13.98.49c.14.32.08.73.35.95.28.23.74.05.9-.28s.11-.71.01-1.06c-.16-.59-.41-1.15-.46-1.76s.16-1.29.71-1.56"
        style={{
          fill: '#f1cc5b',
          stroke: '#b59745',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: 0.75,
        }}
      />
      <path
        d="M18.27,15.52c-.02.19.09.36.21.51.41.53,1,.91,1.64,1.08.12.03.25.05.37.02"
        style={{
          fill: 'none',
          stroke: '#b59745',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: 0.75,
        }}
      />
      <path
        d="M28.68,11.1c-.96-.31-1.87.29-.27,1.18,1.03.58,3.02.52,1.63-.42"
        style={{
          fill: 'none',
          stroke: '#b59745',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: 0.75,
        }}
      />
      <path
        d="M33.13,12.65c.33.03,1.8-.29,2.12-.35.33.66,1.08,1.66,1.67,2.1-.15.29-1,1.35-.96,1.68"
        style={{
          fill: '#f1cc5b',
          stroke: '#b59745',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: 0.75,
        }}
      />
      <path
        d="M17.94,10.6c-.25.12-.55.03-.8-.11s-.47-.32-.74-.39c-.27-.06-.56-.04-.81.08-2.03,1.06-1.44,1.84-1.85,3.19"
        style={{
          fill: '#f1cc5b',
          stroke: '#b59745',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: 0.75,
        }}
      />
      <path
        d="M14.27,11.43c.73-.14,1.38-.62,1.73-1.28"
        style={{
          fill: '#b59745',
          stroke: '#b59745',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: 0.75,
        }}
      />
      <path
        d="M26.4,17.53c3.25-3.19,5.97.13,5.97.13,0,0-2.49-2.62-4.83.12-1,1.17-3.36,1.93-1.14-.25Z"
        style={{
          fill: '#b59745',
          stroke: '#b59745',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: 0.75,
        }}
      />
      <path
        d="M28.98,27.55c-.2.56.1,1.26.65,1.49"
        style={{
          fill: 'none',
          stroke: '#b59745',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: 0.75,
        }}
      />
      <path
        d="M39.37,23.85v.41c-.2,7.63-5.88,13.91-13.26,15-.75.12-1.53.18-2.31.18-3.75,0-7.2-1.32-9.87-3.54,1.82.68,3.8,1.05,5.87,1.05.85,0,1.69-.07,2.52-.19,8-1.2,14.17-8,14.39-16.29.01-.15.01-.29.01-.44,0-2.34-.47-4.57-1.33-6.59,2.49,2.76,4,6.4,4,10.41Z"
        style={{ fill: '#000', mixBlendMode: 'multiply', opacity: 0.31 }}
      />
      </g>
    </>
  </AvatarArtwork>
  );
};
